import { t } from 'i18next'

export const SHIPPING_INFORMATION_TITLE = t('order.shipping.info')
export const SHIPPING_INFORMATION_TITLE_SHORT = t('order.shipping.titleShort')
